<script lang="ts">
import type { Component } from 'svelte'

type Props = {
	icon: Component
	testId?: string
}

let { icon, testId }: Props = $props()

const SvelteComponent = $derived(icon)
</script>

<div class="w-6 h-6 flex-center bg-slate-300 text-white text-sm rounded-full" data-testid={testId}>
	<SvelteComponent />
</div>
